import "./SectionHeader.css";
import { ReactNode, useEffect, useLayoutEffect, useRef, useState } from "react";
import Icon from "../../base/Icon";
import { FontAwesomeIcons } from "../../../core/Types";


export interface SectionHeaderTab {
    id: string
    name: string
    visible?: boolean
}

interface SectionHeaderProps {
    title: string
    icon?: FontAwesomeIcons
    actions?: ReactNode
    tabsActions?: ReactNode
    tabs?: SectionHeaderTab[]
    activeTab?: string
    onTabChange?: (id: string) => void
}


export default function SectionHeader(props: SectionHeaderProps) {

    const visibleTabs = (props.tabs ?? []).filter(t => t.visible !== false)

    const tabsContainerRef = useRef<HTMLDivElement>(null)
    const tabRefs = useRef<Record<string, HTMLButtonElement | null>>({})

    const [indicator, indicatorSet] = useState<{ left: number; width: number }>({ left: 0, width: 0 })

    const updateIndicator = () => {
        if (!props.activeTab) return
        const el = tabRefs.current[props.activeTab]
        if (!el) return
        indicatorSet({ left: el.offsetLeft, width: el.offsetWidth })
    }

    useLayoutEffect(() => {
        updateIndicator()
    }, [props.activeTab, visibleTabs.length])

    useEffect(() => {
        const onResize = () => updateIndicator()
        window.addEventListener("resize", onResize)
        return () => window.removeEventListener("resize", onResize)
    }, [props.activeTab])

    return (
        <div className="section-header">
            <div className="section-header-top">
                <h2 className="section-header-title">
                    {
                        props.icon &&
                        <Icon icon={props.icon} type="solid" className="section-header-title-icon" />
                    }
                    {props.title}
                </h2>
                {
                    props.actions &&
                    <div className="section-header-actions">
                        {props.actions}
                    </div>
                }
            </div>

            {
                visibleTabs.length > 0 &&
                <div className="section-header-tabsrow">
                    <div ref={tabsContainerRef} className="section-header-tabs">
                        {
                            visibleTabs.map(t => {
                                const active = props.activeTab === t.id
                                return (
                                    <button key={`section-header-tab-${t.id}`}
                                        ref={el => { tabRefs.current[t.id] = el }}
                                        type="button"
                                        className={`section-header-tab ${active ? "section-header-tab-active" : ""}`}
                                        onClick={() => props.onTabChange?.(t.id)}>
                                        {t.name}
                                    </button>
                                )
                            })
                        }
                        <div className="section-header-tab-indicator"
                            style={{
                                transform: `translateX(${indicator.left}px)`,
                                width: `${indicator.width}px`,
                                opacity: indicator.width > 0 ? 1 : 0
                            }}
                        />
                    </div>

                    {
                        props.tabsActions &&
                        <div className="section-header-tabs-actions">
                            {props.tabsActions}
                        </div>
                    }
                </div>
            }
        </div>
    )
}
